<template>
    <div>
        <div v-for="(item, idx) in filteredItemTypeOptions" :key="item.id" class="accordion-box p-0" :style="customColor">
            <a block href="javascript:void(0)" v-b-toggle="'accordion' + item.id" variant="light" :style="customColor"
                class="accordion-header left-sign">
                <span> {{ item.name }}</span>
            </a>
            <b-collapse :id="'accordion' + item.id" :style="customColor" :visible="true" role="tabpanel"
                v-model="accordianModelArray[idx]">
                <DisplayAccordionOrderItems :displaySelect="false" @toggleAssignment="hideTotals = $event"
                    :filtered-items="listTypeItems(item.id)" :customer-assets="order.assets" :item-type-id="item.id"
                    @view-item="setItemView" @order-status="getOrderCompletionStatus">
                </DisplayAccordionOrderItems>
            </b-collapse>
            <view-item :order-model="order" ref="viewItem" :officer="officer" :customer-assets="order.assets" />
        </div>
        <div v-if="hasPricing">
            <b-row>
                <b-col cols="9">
                    <b class="float-right">{{$translate('total')}}</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <b>${{ itemsTotals.total | currency }}</b>
                </b-col>
            </b-row>

            <b-row class="my-2">
                <b-col cols="9">
                    <b class="float-right">{{ $translate(adjustmentTotals.title) }}</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <span>${{ adjustmentTotals.total | currency }}</span>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="9">
                    <b class="float-right">{{$translate('total_tax')}}</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <span>${{
                        (itemsTotals.tax + adjustmentTotals.tax) | currency
                    }}</span>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="9">
                    <b class="float-right">{{$translate('grand_total')}}</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <b>${{
                        (itemsTotals.tax +
                            itemsTotals.total +
                            adjustmentTotals.total +
                            adjustmentTotals.tax)
                        | currency
                    }}</b>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import DisplayAccordionOrderItems from '../Orders/DisplayAccordionOrderItems'
import ViewItem from '../Orders/ViewItem.vue'

export default {
    name: 'service-request-items',
    components: {
        DisplayAccordionOrderItems,
        ViewItem,
    },
    props: ['order'],
    data() {
        return {
            accordianModelArray: [],

            hideTotals: false,
            items: [],
        }
    },

    filters: {
        currency: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
    },

    computed: {
        fields() {
            return [
                { key: 'id', label: '' },
                { key: 'name', label: this.$translate('name') },
                { key: 'order_item_type_id', label: this.$translate('activity_item_type') },
                { key: 'quantity', label: this.$translate('quantity') },
                { key: 'uom', label: this.$translate('uom') },
                { key: 'price', label: this.$translate('price') },
                { key: 'tax_rate', label: this.$translate('tax') },
            ]
        },
        customColor() {
            const data = this.$store.state.company.settings || {}
            const colors = {
                'background-color': data.background_color + '!important',
                color: data.text_color + '!important',
            }
            return colors
        },
        orderPricing() {
            return this.$store.getters['orderItemStore/orderPricing']
        },
        storedItems() {
            return this.$store.state.orderItemStore.items
        },

        itemTypes() {
            return this.$store.state.itemType.items
        },
        hasPricing() {
            return this.$store.getters['orderItemStore/hasPricing']
        },

        itemsTotals() {
            return this.$store.getters['orderItemStore/itemsTotals']
        },

        adjustmentTotals() {
            return this.$store.getters['orderItemStore/adjustmentTotals']
        },

        officer() {
            return this.$store.state.users.user
        },
        filteredItemTypeOptions() {
            const { itemTypes } = this

            if (!itemTypes) return []
            const onlyUnique = (value, index, array) =>
                array.indexOf(value) === index

            const selectedItemType = id => itemTypes.find(t => t.id == id)

            const list = this.storedItems
                .map(i => i.order_item_type_id)
                .filter(onlyUnique)
                .map(selectedItemType)

            console.log('filteredItemTypeOptions', list)

            return list
        },
    },
    watch: {
        filteredItemTypeOptions: {
            handler: function (val) {
                this.generateItems(val)
            },
            deep: true,
        },
        storedItems: {
            handler: function (items) {
                console.log('stored items', items)
            },
            deep: true,
        },
        orderItems: {
            //load items
            handler: function (items) {
                this.loaditems(items)
            },
            deep: true,
        },
        order: {
            deep: true,
            // immediate: true,
            handler(newItem) {
                this.items = newItem.items
                this.loaditems(newItem.items, 'mounted')
                this.loadedItemTypes = this.getLoadedItemTypes(newItem.items)
            },
        },
    },
    mounted() {
        this.$store.dispatch('itemType/fetchAll')
        console.log('this.storedItems', this.storedItems)
        this.generateItems(this.filteredItemTypeOptions)
    },
    methods: {
        listTypeItems(id) {

          
            return this.storedItems.filter(x => x.order_item_type_id == id && x.customer_completion == 1)
        },
        loaditems(items) {
            console.log('service request items', items)
            const cloneItems = []
            for (const item of items) {
                const _item = { ...item }
                const assets = _item.assets.map(i => i.asset_id)
                this.$set(_item, 'assets', assets)
                cloneItems.push(_item)
            }
            console.log('cloneitems', cloneItems)
            this.$store.dispatch('orderItemStore/load', cloneItems)
        },
        getOrderCompletionStatus(value) {
            console.log('^^^^^^^^^^^ Completion Status', value)
        },
        getLoadedItemTypes(orderItems) {
            const itemTypes = orderItems

            console.log('ACTIVITY ITEM TYPES LOADED: ', itemTypes)
            return itemTypes
        },

        generateItems(items) {
            this.accordianModelArray.splice(0)
            this.accordianModelArray.push(
                ...[...Array(items.length).keys()].map(() => true)
            )

            console.log('accordion model', this.accordianModelArray)
        },
        setItemView(hash) {
            console.log('item hash', hash)
            const item = this.storedItems.find(x => x.hash === hash)
            this.$refs['viewItem'] && this.$refs['viewItem'].showItem(item)
        },
    },
}
</script>
